import {AsyncActDecorator} from '@gongxigames/framework/slotV2/fsm/acts/decorators/AsyncActDecorator';
import {BROWSER_NOT_SUPPORTED, WEBGL_CAN_NOT_SUPPORTED} from '@gongxigames/framework/slot';

export class CheckDeviceIsSupportedAct extends AsyncActDecorator {
    public async execute(): Promise<void> {
        if (!this.device.isSupported()) {
            // can not supported device
            const error = this.device.ie ? BROWSER_NOT_SUPPORTED : WEBGL_CAN_NOT_SUPPORTED;

            this.eventManager.emit('General.Message.SHOW', error);

            throw new Error('WebGl is not supported!');
        }
    }

    getName(): string {
        return 'CheckDeviceIsSupportedAct';
    }
}